import React, { Component } from 'react';
import { Box, Typography } from '@mui/material';
import { ALERT_SEVERITY } from './AlertDisplay2';

class DeletableChip extends Component {
    onDelete = () => {
        const { disabled, onDelete, showAlert } = this.props;

        if (disabled) {
            showAlert?.('Die Daten können nicht bearbeitet werden.', ALERT_SEVERITY.WARNING);
            return;
        }

        onDelete?.();
    };

    render() {
        const { label, children, style, deleteIcon, hideDelete } = this.props;

        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    minWidth: 0,
                    boxSizing: 'border-box',
                    border: '0.5px solid rgba(211,211,211,0.91)',
                    borderRadius: '6px',
                    p: 1.25,
                    overflow: 'hidden',
                    ...style,
                }}
            >
                <Box
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        overflow: 'hidden',
                    }}
                >
                    {children != null ? (
                        children
                    ) : (
                        <Typography
                            sx={{
                                color: '#353535',
                                fontSize: 14,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {label}
                        </Typography>
                    )}
                </Box>

                {!hideDelete && (
                    <Box
                        onClick={this.onDelete}
                        sx={{
                            width: 40,
                            minWidth: 40,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            pr: 0.5,
                            cursor: 'pointer',
                            flexShrink: 0,
                        }}
                    >
                        <Box
                            sx={{
                                width: 20,
                                height: 20,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Box
                                component="img"
                                src={deleteIcon || require('../assets/icons/close.png')}
                                alt=""
                                sx={{
                                    width: 10,
                                    height: 10,
                                    objectFit: 'contain',
                                }}
                            />
                        </Box>
                    </Box>
                )}
            </Box>
        );
    }
}

export default DeletableChip;